
import { Component, Vue, Prop } from 'vue-property-decorator';
import { MessageModel, AuthorType } from './MessageModel';

@Component
export default class JoeyMessage extends Vue {
    @Prop() message: MessageModel;

    public get messageModifier() {
        switch (this.message.author) {
            case AuthorType.Joey:
                return 'chatbot-message-group--joey';
            case AuthorType.User:
                return 'chatbot-message-group--user';
            default:
                return '';
        }
    }
}
